var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 -1 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01352 14.3558C8.01352 14.3558 10.1546 13.114 11.1 12.3594C12.5922 11.1683 14.1099 9.6764 15.3 7.35583C16.6454 4.70583 16.0194 1.82732 14 0.555828C13.0181 -0.0623941 11.3851 -0.215547 10.1 0.355808C8.96203 0.861739 8.00676 2.35583 8.00676 2.35583C8.00676 2.35583 7.05149 0.861737 5.91354 0.355808C4.62843 -0.215547 2.99541 -0.0623941 2.01353 0.555828C-0.0058918 1.82732 -0.631876 4.70583 0.713537 7.35583C1.90361 9.6764 3.42132 11.1683 4.91354 12.3594C5.84905 13.1061 8.01352 14.3558 8.01352 14.3558Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilled);
export default __webpack_public_path__ + "static/media/likeFilled.6ce8e747fb14995a2bc86bc6a9aa105a.svg";
export { ForwardRef as ReactComponent };